import Icon from '../components/Icon.vue'

Icon.register({
  'id-card-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 64H384V160H192V64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H528C554.5 512 576 490.5 576 464V112C576 85.5 554.5 64 528 64zM288 224C323.3 224 352 252.7 352 288S323.3 352 288 352 224 323.3 224 288 252.7 224 288 224zM381.3 448H194.7C184.3 448 175.9 438 179.1 428.2 187.4 402.6 211.5 384 240 384H248.2C260.5 389.1 273.9 392 288 392S315.6 389.1 327.8 384H336C364.4 384 388.5 402.5 396.9 428.2 400.1 438 391.7 448 381.3 448zM352 32C352 14.3 337.7 0 320 0H256C238.3 0 224 14.3 224 32V128H352V32z'
      }
    ]
  }
})
